import * as React from "react";

export const FileSharing = (props: { className?: string; color: string }): JSX.Element => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 6C2 4.89543 2.89543 4 4 4H9.58579C9.851 4 10.1054 4.10536 10.2929 4.29289L11.7071 5.70711C11.8946 5.89464 12.149 6 12.4142 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM4 5.5C3.72386 5.5 3.5 5.72386 3.5 6V18C3.5 18.2761 3.72386 18.5 4 18.5H20C20.2761 18.5 20.5 18.2761 20.5 18V8C20.5 7.72386 20.2761 7.5 20 7.5H12.4142C11.7481 7.5 11.1094 7.23661 10.6339 6.76777L9.27614 5.5H4Z"
            fill={props.color}
        />
    </svg>
);
